import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin((nuxtApp) => {
	const router = useRouter()
	const config = useRuntimeConfig()

	Sentry.init({
		app: nuxtApp.vueApp,
		dsn: config.public.sentry.dsn,
		integrations: [
			Sentry.browserTracingIntegration({ router }),
			Sentry.browserProfilingIntegration(),
			Sentry.replayIntegration(),
		],
		tracesSampleRate: 0.5,
		profilesSampleRate: 1.0,
		replaysSessionSampleRate: 0,
		replaysOnErrorSampleRate: 1.0,
	})
})